import React from "react"
import {useTranslation} from "react-i18next"

import {useDataSources as useItems} from "../../contexts/DataSourceContext"

import ItemList from '../../components/DataSources/List'
import PageList from '../common/List'

const PageDataSourcesList: React.FC = () => {

    const { t } = useTranslation()

    const { fetchItems } = useItems()

    const
        itemType: string     = 'DataSource',
        itemTypeName: string = t('data-sources.title_list'),
        itemTypeUrl: string  = 'datasources'

    return (
        <PageList
            ItemList={ItemList}
            itemType={itemType}
            itemTypeName={itemTypeName}
            itemTypeUrl={itemTypeUrl}
            showAddButton={false}
            fetchItems={fetchItems}
            useItems={useItems}
        />
    )
}

export default PageDataSourcesList